/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-18 11:39:50
 * @LastEditors: hongye
 * @LastEditTime: 2026-01-29 10:10:26
 * @Description: 引入语言包
 */
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import msMY from 'ant-design-vue/lib/locale-provider/ms_MY'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import viVN from 'ant-design-vue/lib/locale-provider/vi_VN'
import idID from 'ant-design-vue/lib/locale-provider/id_ID'

import { Locale } from 'ant-design-vue/lib/locale-provider'
import { LangType, localeSuper } from '@/utils/i18n/LangType'
const MODE = import.meta.env.MODE
if (MODE === 'development') {
  import('dayjs/locale/zh-cn.js')
  import('dayjs/locale/ms-my.js')
  import('dayjs/locale/en.js')
  import('dayjs/locale/vi.js')
  import('dayjs/locale/id.js')
}
type Lang = keyof typeof LangType

const langJsonConfig = {
  [LangType.zh]: zhCN,
  [LangType.en]: enUS,
  [LangType.ms]: msMY,
  [LangType.vn]: viVN,
  [LangType.id]: idID
}
const localeMap = Object.values(localeSuper).reduce((pre, cur) => {
  pre[cur.short] = {
    dayjs: localeSuper[cur.type].dayjsType,
    antd: langJsonConfig[cur.type],
  }
  return pre
}, {} as Record<Lang, { dayjs: string; antd: Locale }>)
console.log(localeMap);

export { localeMap, langJsonConfig }
